import { ScrollView, TextBox, NumberBox } from 'devextreme-react';
import React, { useEffect } from 'react';
import { Button, Popup } from 'devextreme-react';
import { Form, SimpleItem, GroupItem, Label } from 'devextreme-react/form';
import { FormatLineNumber, FormatNumber } from '../../common';
import CorpListCardInfoPopupContainer from './corp-list-card-info-popup-container';

const CorpListDetailInfoPopup = ({
  onHiding,
  onFieldDataChanged,
  onValueChanged,
  onClickLineNumberSearch,
  onClickInsert,
  onClickUpdate,
  onClickDelete,
  onClickUseInfo,
  onClickUpdateInfo,
  onClickPaymentState,
  detailInfo,
  detailInfoMode,
  visibleDetailInfoPopup,
  itemsUseCheck,
}) => {
  // console.log('CorpListDetailInfoPopup Load');

  useEffect(() => {
    // console.log('CorpListDetailInfoPopup > useEffect()');
  }, [visibleDetailInfoPopup, detailInfo]);

  return (
    <React.Fragment>
      <Popup
        className="popup"
        title={'법인 사용자 ' + (detailInfoMode === 'I' ? '등록' : '상세정보')}
        visible={visibleDetailInfoPopup}
        onHiding={onHiding}
        width={500}
        height="90vh"
      >
        <ScrollView showScrollbar="never">
          <div className="corp-list-detail-info-content popup-content">
            <Form
              formData={detailInfo}
              labelLocation={'left'}
              minColWidth={50}
              onFieldDataChanged={onFieldDataChanged}
            >
              <GroupItem caption="고객 전화번호">
                <SimpleItem dataField="LineNumber" editorType="dxTextBox">
                  <Label text="전화번호" />
                  <div className="flex-row">
                    <TextBox
                      className={
                        'flex' +
                        (detailInfo.LineNumberSeachState === 1
                          ? ''
                          : ' read-only')
                      }
                      readOnly={
                        detailInfo.LineNumberSeachState === 1 ? false : true
                      }
                      value={FormatLineNumber(detailInfo.LineNumber)}
                      onValueChanged={(e) => onValueChanged('LineNumber', e)}
                    />
                    <Button
                      visible={detailInfoMode === 'I' ? true : false}
                      onClick={onClickLineNumberSearch}
                      text={
                        detailInfo.LineNumberSeachState === 1
                          ? '조회'
                          : '재등록'
                      }
                    />
                  </div>
                </SimpleItem>
              </GroupItem>
              <GroupItem caption="일반고객 정보">
                <SimpleItem dataField="Name" editorType="dxTextBox">
                  <Label text="이름" />
                </SimpleItem>
                <SimpleItem dataField="Dong" editorType="dxTextBox">
                  <Label text="일반주소" />
                </SimpleItem>
                <SimpleItem dataField="Address" editorType="dxTextBox">
                  <Label text="상세주소" />
                </SimpleItem>
                <SimpleItem dataField="TypeName" editorType="dxTextBox">
                  <Label text="고객구분" />
                  <TextBox
                    className="read-only"
                    readOnly={true}
                    value={detailInfo.TypeName}
                  />
                </SimpleItem>
                <SimpleItem dataField="Part" editorType="dxTextBox">
                  <Label text="부서" />
                </SimpleItem>
                <SimpleItem dataField="Duty" editorType="dxTextBox">
                  <Label text="직책" />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption="이용한도 설정">
                <SimpleItem dataField="UseCheck">
                  <Label text="이용제한 타입" />
                  {itemsUseCheck.map((item) => (
                    <label key={item.key} className="margin-r1r hover">
                      <input
                        type="radio"
                        name="UseCheck"
                        className="hover"
                        value={item.key}
                        checked={detailInfo.UseCheck === item.key}
                        onChange={(e) => onValueChanged('UseCheck', e.target)}
                      />
                      {item.value}
                    </label>
                  ))}
                </SimpleItem>
                <SimpleItem dataField="UseCheckValue">
                  <Label
                    text={
                      '이용한도' +
                      (detailInfo.UseCheck === 0
                        ? ''
                        : detailInfo.UseCheck === 1
                        ? '(원)'
                        : '(회)')
                    }
                  />
                  <NumberBox
                    className={detailInfo.UseCheck === 0 ? 'read-only' : ''}
                    format={'#,##0'}
                    readOnly={detailInfo.UseCheck === 0 ? true : false}
                    value={
                      detailInfo.UseCheck === 0 ? 0 : detailInfo.UseCheckValue
                    }
                    onValueChanged={(e) => onValueChanged('UseCheckValue', e)}
                  />
                </SimpleItem>
              </GroupItem>
              {detailInfoMode === 'U' && (
                <GroupItem caption="개별 결제 등록">
                  <SimpleItem dataField="PaymentStateText">
                    <Label text="결제카드 등록상태"></Label>
                    <div className="flex-row">
                      <TextBox
                        className={'flex read-only'}
                        value={detailInfo.PaymentStateText}
                        readOnly={true}
                      />
                      <Button
                        text={
                          detailInfo.PaymentState === 0
                            ? '카드등록'
                            : '등록해지'
                        }
                        type={
                          detailInfo.PaymentState === 0 ? 'default' : 'danger'
                        }
                        onClick={onClickPaymentState}
                      />
                    </div>
                  </SimpleItem>
                </GroupItem>
              )}
              {detailInfoMode === 'U' && (
                <GroupItem caption="월 이용내역">
                  <SimpleItem dataField="SHCNT">
                    <Label text="이용횟수" />
                    <NumberBox
                      className="read-only"
                      format={'#,##0'}
                      readOnly={true}
                      value={detailInfo.SHCNT}
                    />
                  </SimpleItem>
                  <SimpleItem dataField="TotCharge">
                    <Label text="이용금액" />
                    <NumberBox
                      className="read-only"
                      format={'#,##0'}
                      readOnly={true}
                      value={detailInfo.TotCharge}
                    />
                  </SimpleItem>
                </GroupItem>
              )}
            </Form>
          </div>
          {detailInfoMode === 'I' ? (
            <div className="corp-list-detail-info-bottom">
              <Button
                stylingMode="contained"
                type="default"
                text="등록"
                onClick={onClickInsert}
              />
              <Button
                stylingMode="contained"
                type="normal"
                text="닫기"
                onClick={onHiding}
              />
            </div>
          ) : (
            <div className="corp-list-detail-info-bottom">
              <Button
                stylingMode="contained"
                type="success"
                text="이용내역"
                onClick={onClickUseInfo}
              />
              <Button
                stylingMode="contained"
                type="success"
                text="변경내역"
                onClick={onClickUpdateInfo}
              />
              <Button
                stylingMode="contained"
                type="default"
                text="수정"
                onClick={onClickUpdate}
              />
              <Button
                stylingMode="contained"
                type="danger"
                text="해지"
                onClick={onClickDelete}
              />
              <Button
                stylingMode="contained"
                type="normal"
                text="닫기"
                onClick={onHiding}
              />
            </div>
          )}
        </ScrollView>
      </Popup>
      <CorpListCardInfoPopupContainer
        customerCode={detailInfo.CustomerCode}
        corpType={1}
      />
    </React.Fragment>
  );
};

export default React.memo(CorpListDetailInfoPopup);
